import { AlertColor } from '@mui/material';
import ENVIRONMENT from './environment';

export const VERSION: string = '1.5.0';
export const ENV_CONFIG: string = ENVIRONMENT.PROD;

export const CHANGE_LOG = [
  { version: '2023/01/15:Ver.1.0.0', contents: ['・First version release'] },
  {
    version: '2024/07/29:Ver.1.1.0',
    contents: ['・Add ESN-100 & GT/iX-1500/700'],
  },
  {
    version: '2024/12/02:Ver.1.2.0',
    contents: ['・Add LN-160'],
  },
  {
    version: '2025/11/25:Ver.1.3.0',
    contents: [
      '・Add LN-1000i',
      '・Support new password policy',
      '・Eliminate account registration button and activation email resend button from login screen',
    ],
  },
  {
    version: '2026/03/31:Ver.1.4.0',
    contents: ['・Add GTS/SET-M1'],
  },
  {
    version: '2026/08/06:Ver.1.5.0',
    contents: ['・Add GM/iM-120'],
  },
];

export namespace SNACKBAR {
  export namespace SEVERITY {
    export const ERROR: AlertColor = 'error';
    export const WARNING: AlertColor = 'warning';
    export const INFO: AlertColor = 'info';
    export const SUCCESS: AlertColor = 'success';
  }
}

export namespace MYTOPCON {
  export namespace LINK {
    export const PROD: string =
      'https://www.topconpositioning.com/accounts/profile/create';
    export const QA: string =
      'https://topcon-gl-stg.topconpositioning.com/accounts/profile/create';
  }
}

export { default as REGEX } from './regex';
export { default as INDUSTRY } from './industry';
export { default as ENVIRONMENT } from './environment';
